import React from 'react'
import { FloraVariants, forwardRef, styled } from '@grupoboticario/flora-react-system'
import { HTMLFloraProps } from '@grupoboticario/flora-react-utils'

const StyledContainer = styled('div', {
  boxSizing: 'border-box',
  flexShrink: 0,
  marginInline: 'auto',
  paddingInline: '$4',
  width: '100%',

  variants: {
    size: {
      small: {
        maxWidth: '420px',
      },
      medium: {
        maxWidth: '768px',
      },
      large: {
        maxWidth: '1200px',
      },
    },
    centerContent: {
      true: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
  },
})

export type ContainerProps = HTMLFloraProps<'div'> & FloraVariants<typeof StyledContainer>

/**
 * @component
 * @name Container
 * @description Container component
 * @tutorial https://flora.gb.tech/docs/components/core/container
 */
export const Container = forwardRef<'div', ContainerProps>((props, forwardedRef) => {
  return <StyledContainer ref={forwardedRef} {...props} />
})
